import type { McpTool } from "@p0security/shared/types/agentic/mcp";

import { SnowflakeAiObjects } from "./constants.ts";

// What the server's tools/list returned on a live account (2026-10-22). The
// description is the one in the MCP server's specification. The gateway
// can't call tools/list itself when it syncs, since that needs a grant's
// token, so the tool is listed here.
export const snowflakeAiMcpTools: McpTool[] = [
  {
    name: SnowflakeAiObjects.mcpTool,
    title: "SQL Execution Tool",
    description:
      "Execute SQL in this Snowflake account, as the agent's own Snowflake user.",
    inputSchema: {
      type: "object",
      properties: {
        sql: { type: "string", description: "Single SQL query to execute." },
      },
    },
    annotations: {
      readOnlyHint: false,
      destructiveHint: true,
      idempotentHint: false,
      openWorldHint: true,
    },
  },
];
